import React from "react"
import { Box, Card, CardActionArea, CardContent, Typography } from "@material-ui/core"
import { isMobile } from 'react-device-detect';
import '../templates/five_ch-post.scss'

const PrevNext = ({ prev, next }) => {
  if(prev == null && next!=null){
    return(
      <Box mt={5} display="flex" justifyContent="flex-end">
        { prev == null ? null : _link(prev, `prev`)}
        { next == null ? null : _link(next, `next`)}
      </Box>
    )
  }
  else if(next == null && prev!=null){
    return(
      <Box mt={5} display="flex" justifyContent="flex-start">
        { prev == null ? null : _link(prev, `prev`)}
        { next == null ? null : _link(next, `next`)}
      </Box>
    )
  }
  else{
    return(
      <Box mt={5} display="flex" justifyContent="space-between">
        { prev == null ? null : _link(prev, `prev`)}
        { next == null ? null : _link(next, `next`)}
      </Box>
    )
  }
}
export default PrevNext

const _link = ({ fields, top_image, title }, direction) =>{
if(!isMobile){
  return(
    <Box display="flex" flexDirection="column" style={{ width: `40%` }}>
      <Typography gutterBottom variant="body2" component="h6">
        { direction == 'prev' ? '<<次の記事' : '前の記事>>'}
      </Typography>
      <Card style={{ width: `100%`, height: `100%`}}>
        <CardActionArea href={"/" +fields.slug} style={{ display: 'flex', alignItems: `stretch`, height: `100%` }}>
          <Box style={{ width: `35%` }}>
            <img src={top_image} style={{ width: `100%`, height: '100%', display:'block' }} />
          </Box>
          <CardContent style={{ flex: `1` }}>
            <Typography variant="body2" component="p">
              {title}
            </Typography>
          </CardContent>
        </CardActionArea>
      </Card>
    </Box>
  )
}
else{
    return(
        <Box display="flex" flexDirection="column" style={{ width: `40%` }}>
      <Typography gutterBottom variant="body2" component="h6">
        { direction == 'prev' ? '<<次の記事' : '前の記事>>'}
      </Typography>
      <Card style={{ width: `100%`, height: `50%`}}>
        <CardActionArea href={"/" + fields.slug} style={{ display: 'flex', alignItems: `stretch`, height: `100%` }}>
          <Box style={{ width: `35%` }}>
            <img src={top_image} style={{ width: `50px`, height: '100%', display:'block' }} />
          </Box>
          <CardContent style={{ flex: `1` }} style={{padding:'none',paddingTop:'5px'}}>
            <Typography variant="body2" component="div" style={{fontSize:'10px', display: '-webkit-box', textOverflow:'ellipsis'}}>
              {title}
            </Typography>
          </CardContent>
        </CardActionArea>
      </Card>
    </Box>
      )
  }
}